import { render, staticRenderFns } from "./BlockHeadLine.vue?vue&type=template&id=a9cfbf44&scoped=true"
import script from "./BlockHeadLine.vue?vue&type=script&lang=js"
export * from "./BlockHeadLine.vue?vue&type=script&lang=js"
import style0 from "./BlockHeadLine.vue?vue&type=style&index=0&id=a9cfbf44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cfbf44",
  null
  
)

export default component.exports